<template>
	<div>
    <div class="popup_high_right topup-popup"
         :class="['level-'+level,{}]">
      <Loading v-show="loading"/>

	    <a @click="closePopup" v-if="!level" class="close_popup_btn">
		    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
	    </a>

            <div class="popup-container scroll">
	            <h3 class="title" >
		            <back-btn v-if="level" class="back-btn" @click="$emit('close')" />
		            Top up
		            <span></span>
	            </h3>

	            <div class="layout-column ">
                <span class="headline">
			            <v-switch v-model="topup.topup_auto" :value="topup.topup_auto"
			                      label="Enable auto top up (recommended)" />
		            </span>
	            </div>

	            <div class="layout-column flex " >
		            <div class="layout-column margin-b-10 " :class="{'disabled':!topup.topup_auto}">
			            <label class="margin-b-10">Add <b>{{amount}}</b> to my account</label>
			            <select-field :options="topupOptions"
			                          v-model="topup.topup_amount"
			                          label="label"
			                          :searchable="false" :clearable="false"
			                          small
			                          append-to-body/>
		            </div>
		            <div class="layout-row margin-b-20" :class="{'disabled':!topup.topup_auto}">
			            <div class="flex layout-column margin-r-15">
				            <label class="margin-b-10">When my balance falls below: <b>{{minBalance}}</b></label>
				            <select-field :options="balanceMinOptions"
				                          v-model="topup.topup_min_balance"
				                          label="label"
				                          :searchable="false" :clearable="false"
				                          small
				                          append-to-body/>
			            </div>

			            <div class="flex layout-column">
				            <label class="margin-b-10">And never exceed <b>{{maxSpend}}</b> per month</label>
				            <select-field :options="maxSpendOptions"
				                          v-model="topup.topup_max_spend"
				                          label="label"
				                          :searchable="false" :clearable="false"
				                          small
				                          append-to-body/>
			            </div>
		            </div>

		            <div class="or-wrapper">
			            <h2>Or</h2>
			            <div class="line"></div>
		            </div>

		            <div class="flex layout-column">
			            <v-button class="one-time-btn" label="Make a one-time payment"
			                      @click="onetimeTopupOpen=true" border
			                      :icon="require('@/assets/img/arrow-right.svg')" />
		            </div>
	            </div>

	            <div style="min-height: 10px"></div>
            </div>

	    <div class="popup-actions layout-row">
		    <v-button label="Save changes" @click="save" :loading="saving" />
		    <v-button label="Cancel" border @click="$emit('close')" />
	    </div>


    </div>

			<popup-backdrop v-if="onetimeTopupOpen" @close="onetimeTopupOpen=false">
				<one-time-topup-popup :funnel-id="funnelId" :level="level+1"
				                      @close="onetimeTopupOpen=false"
				                      @done="onetimeTopupOpen=false;$emit('done', $event)"/>
			</popup-backdrop>

	</div>
</template>

<script>
import API from "@/api"
import Tooltip from "@/components/Tooltip.vue"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import InfoIcon from "@/components/base/info-icon";
import InputField from "@/components/base/input-field";
import SelectField from "@/components/base/select-field";
import numbers from "@/helpers/numbers";
import PopupBackdrop from "@/components/base/popup-backdrop";
import BackBtn from "@/components/base/back-btn";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import {mapGetters} from "vuex";
import TrackingCodeEntry from "@/views/funnels/funnel-plus/funnel/tracking_codes/tracking_code_entry";
import VRadio from "@/components/base/v-radio";
import VSwitch from "@/components/base/v-switch";
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';
import ExternalLink from "@/components/base/external-link";
import OneTimeTopupPopup from "@/views/funnels/funnel-plus/funnel/sms_numbers/one-time-topup_popup"; // import syntax highlighting styles

export default {
	name: "topup-popup",
	mixins: [API],
	components: {
		OneTimeTopupPopup,
		ExternalLink,
		VSwitch,
		VRadio,
		TrackingCodeEntry,
		QuickActionsBtn,
		BackBtn,
		PopupBackdrop,
		SelectField,
		InputField,
		InfoIcon,
		VButton,
		Tooltip,
		Loading
	},
	props:{
		level: {
			type: Number,
			default: 0,
		},
		funnelId: {
			type: Number,
			default: 0,
		},
		smsAccount:{

		},
	},
	data() {
		return {
			onetimeTopupOpen: false,
			saving: false,
			loading: false,
			topup:{
				topup_amount:100,
				topup_min_balance:10,
				topup_max_spend:200,
				topup_auto:true,
			},
			topupOptions:[
				{id:20,label:"$20"},
				{id:50,label:"$50"},
				{id:100,label:"$100"},
				{id:200,label:"$200"},
				{id:400,label:"$400"},
				{id:800,label:"$800"},
				{id:1000,label:"$1,000"},
				{id:2000,label:"$2,000"},
			],
			balanceMinOptions:[
				{id:10,label:"$10"},
				{id:20,label:"$20"},
				{id:50,label:"$50"},
				{id:100,label:"$100"},
				{id:200,label:"$200"},
				{id:400,label:"$400"},
				{id:800,label:"$800"},
				{id:1000,label:"$1,000"},
			],
		}
	},
	computed:{
		maxSpendOptions(){
			return [
				{id:100,label:"$100"},
				{id:200,label:"$200"},
				{id:500,label:"$500"},
				{id:1000,label:"$1000"},
				{id:2000,label:"$2000"},
				{id:4000,label:"$4000"},
				{id:8000,label:"$8000"},
				{id:10000,label:"$10,000"},
				{id:20000,label:"$20,000"},
				{id:50000,label:"$50,000"},
			]
		},
		amount(){
			return "$"+numbers.numberWithCommas(this.topup.topup_amount)
		},
		minBalance(){
			return "$"+numbers.numberWithCommas(this.topup.topup_min_balance)
		},
		maxSpend(){
			return "$"+numbers.numberWithCommas(this.topup.topup_max_spend)
		},
	},
	methods: {

		roundPrice(n) {
			return numbers.round_to_two(n)
		},
		closePopup() {
			this.$emit('close')
		},

		async save() {
			try {
				this.saving = true;

				let t = await this.api.sms.updateSmsAccount(this.topup);
				if (t.error) this.$error(t.error);
				else {
					this.$emit('done', t)
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.saving = false;
			}
		},
	},
	created() {

		this.topup.topup_auto = this.smsAccount.topup_auto
		this.topup.topup_amount = this.smsAccount.topup_amount || 20;
		this.topup.topup_min_balance = this.smsAccount.topup_min_balance || 10;
		this.topup.topup_max_spend = this.smsAccount.topup_max_spend || 100;

	},
}
</script>
<style lang="scss">
.topup-popup {
	.headline {
		font-size: 16px;
		font-weight: 500;
		margin-top: 20px;
		margin-bottom: 15px;
		color: $darker-grey;
		.text_label {
			font-size: 16px;
			font-weight: 500;
			color: $darker-grey;
		}
	}
}
</style>
<style lang="scss" scoped>
.topup-popup {
	padding: 0;
	.disabled {
		opacity: 0.6;
		pointer-events: none;
	}
	.or-wrapper {
		height: 35px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-bottom: 1.5rem;
		margin-top: 1.5rem;
		h2 {
			margin-bottom: 0;
			background-color: white;
			padding: 0 2rem;
			position: absolute;
			text-transform: uppercase;
		}
		.line {
			width: 100%;
			height: 1px;
			background-color: #e6e8ea;
		}
	}
	.headline {
		font-size: 16px;
		font-weight: 500;
		margin-top: 20px;
		margin-bottom: 15px;
		color: $darker-grey;
	}
	.one-time-btn {
		margin: 10px auto;
	}
	.popup-actions {
		padding: 10px 30px;
		border-top: 1px solid $light-grey;
		.button {
			margin-right: 25px;
		}
	}
	.my-editor {
		font-family: Courier, monospace;
		font-size: 14px;
		line-height: 1.5;
		padding: 5px;
		//height: 25%;
		border-radius: 4px;
		border: 1px solid #ececec;
		background-color: whitesmoke;
		&.focused {
			border: 1px solid $blue;
		}
	}
	&.archived {
		.title {
			color: $dark-grey;
		}
	}
	&.canceled {
		.title {
			text-decoration: line-through;
		}
	}
	.status-tags {
		display: flex;
		flex-direction: row;
		margin-right: 25px;
	}
	.status-tag {
		border-radius: 5px;
		background: $light-silver;
		padding: 3px 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		.value {
			margin: 0 0 0 5px;
		}
		svg {
			//color: #18d7ae;
			height: 18px;
			&.refund {
				color: $black;
			}
		}
		margin-right: 3px;
	}
	&.level-1 {
		max-width: 580px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.10);
	}
	&.level-2 {
		max-width: 560px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.05);
	}
	.title {
		display: flex;
		flex-direction: column;
		align-items: start;
		position: relative;
		.back-btn {
			position: absolute;
			top: -30px;
		}
	}

	.popup_high_right {
		padding: 0;
	}
	.title {
		font-size: 22px;
		line-height: 150%;
		font-weight: 600;
		letter-spacing: 0.02em;
		color: #252A32;
		margin-bottom: 5px;
		background: white;
		min-height: 40px;
	}
	.popup-container {
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: 35px 30px 20px;
	}
}
.order-status-row {
	margin-top: 10px;
	margin-bottom: 10px;
	display: flex;
	flex-direction: row;
	font-size: 13px;
	align-items: center;
	color: #26252e;
	.label {
		font-weight: bold;
		margin-right: 10px;
	}
	.value {
		display: flex;
		flex-direction: row;
		margin-right: 20px;
		margin-left: 5px;
	}
}
.popup_title {
	font-size: 20px;
}
</style>
